import { defineMessages } from 'react-intl';

export default defineMessages({
  badgeDiscountText: {
    id: 'Pdp.fixedBundleAOV.badgeDiscountText',
    description: 'Text for the badge with the calculated discount',
    defaultMessage: '{discountPercentage}% OFF',
  },
});
